const BASE_LOCALE_DEFAULTS = {
  en: "en-US",
  pt: "pt-BR",
  es: "es-ES",
};

const PRIME_LOCALE_FALLBACK = "en";
const SUPPORTED_LANGUAGES = new Set(["en", "pt", "es"]);

export function normalizeLanguage(lang, fallback = "pt") {
  if (!lang) return fallback;
  const raw = String(lang).trim();
  if (!raw) return fallback;

  const base = raw.replace("_", "-").split("-")[0]?.toLowerCase();
  if (base && SUPPORTED_LANGUAGES.has(base)) {
    return base;
  }

  return fallback;
}

export function getIntlLocale(lang) {
  if (!lang) return undefined;
  const raw = String(lang).trim();
  if (!raw) return undefined;

  const cleaned = raw.replace("_", "-");

  // Handle "ptBR"/"enUS"/"esES"
  if (/^[a-zA-Z]{4}$/.test(cleaned) && !cleaned.includes("-")) {
    const base = cleaned.slice(0, 2).toLowerCase();
    const region = cleaned.slice(2).toUpperCase();
    return `${base}-${region}`;
  }

  if (cleaned.includes("-")) {
    const [base, region] = cleaned.split("-");
    if (base && region) {
      return `${base.toLowerCase()}-${region.toUpperCase()}`;
    }
    return cleaned;
  }

  const base = cleaned.toLowerCase();
  return BASE_LOCALE_DEFAULTS[base] || raw;
}

export function getPrimeLocale(lang) {
  if (!lang) return PRIME_LOCALE_FALLBACK;
  const raw = String(lang).trim();
  if (!raw) return PRIME_LOCALE_FALLBACK;

  return normalizeLanguage(raw, PRIME_LOCALE_FALLBACK);
}
